export const getUserShortName = (name) => {
  if (!name) return "";
  const nameParts = name.split(" ");
  let shortName = nameParts[0].charAt(0);
  if (nameParts.length > 1) {
    shortName += nameParts[nameParts.length - 1].charAt(0);
  } else {
    shortName += nameParts[0].charAt(1);
  }
  return shortName.toUpperCase();
};

export const convertSize = (size, fromSizeUnit, toSizeUnit) => {
  const sizeUnits = ["B", "KB", "MB", "GB", "TB"];
  const fromSizeIndex = sizeUnits.indexOf(fromSizeUnit);
  const toSizeIndex = sizeUnits.indexOf(toSizeUnit);
  const sizeInBytes = size * Math.pow(1024, fromSizeIndex);
  return sizeInBytes / Math.pow(1024, toSizeIndex);
};

export function convertSeconds(seconds) {
  const hrs = Math.floor(seconds / 3600);
  const mins = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;

  let result = [];
  if (hrs > 0) result.push(`${hrs}h`);
  if (mins > 0 || hrs > 0) result.push(`${mins}m`); // Show mins if hrs exist
  result.push(`${secs}s`); // Always show seconds

  return result.join(" ");
}
